import React from 'react';
import { Box, SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import s from './BusinessNameTileSkeleton.scss';
export const BusinessNameTileSkeleton = _ref => {
  let _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'small' : _ref$size;
  return /*#__PURE__*/React.createElement(Box, {
    verticalAlign: "middle",
    minHeight: size === 'large' ? '64px' : '56px',
    boxSizing: "border-box",
    borderRadius: "6px",
    padding: "SP3",
    border: "1px solid var(--wds-color-black-600)",
    className: s.tile,
    dataHook: "business-name-tile-skeleton"
  }, /*#__PURE__*/React.createElement(SkeletonGroup, {
    skin: "light",
    className: s.skeletonGroup
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "60%",
    height: "18px"
  })));
};
export const BusinessNameTileSkeletons = _ref2 => {
  let count = _ref2.count,
    keyPrefix = _ref2.keyPrefix,
    size = _ref2.size;
  return /*#__PURE__*/React.createElement(React.Fragment, null, Array.from({
    length: count
  }, (_, i) => /*#__PURE__*/React.createElement(BusinessNameTileSkeleton, {
    key: `${keyPrefix}-${i}`,
    size: size
  })));
};
export const BusinessNamesMobileCtaSkeleton = () => /*#__PURE__*/React.createElement(Box, {
  align: "center",
  paddingTop: "8px",
  width: "100%",
  dataHook: "business-names-mobile-cta-skeleton"
}, /*#__PURE__*/React.createElement(SkeletonGroup, {
  skin: "light",
  className: s.mobileCtaSkeletonGroup
}, /*#__PURE__*/React.createElement(SkeletonRectangle, {
  className: s.mobileCtaSkeleton,
  width: "165px",
  height: "18px"
})));
//# sourceMappingURL=BusinessNameTileSkeleton.js.map